var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',[_c('div',{attrs:{"id":"newsTitle"}},[_c('h1',{staticClass:"text-uppercase px-2"},[_vm._v(" "+_vm._s(_vm.title)+" ")])]),_c('div',{staticStyle:{"margin-right":"100px"}},[_c('p',{staticClass:"py-2"},[_vm._v(" "+_vm._s(_vm.description)+" ")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }